'use client'
import createDictionaryProvider from '@/components/context-factories/create-dictionary-provider'
import { Dictionary } from '@/localization/dictionary'

export const [DictionaryProvider, useDictionary] =
  createDictionaryProvider<Dictionary['navigation']>()
